export var ItemTypes = {
    BOX: "box",
    TEAM: "team",
    PLAYER: "player",
};
